import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-form p-d-flex p-flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Log In", -1)
const _hoisted_3 = { class: "link-login p-mt-2" }
const _hoisted_4 = { class: "link-login p-mt-6" }
const _hoisted_5 = { class: "p-d-flex p-justify-around positioning" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "© 2022 Gameinfluencer GmbH |", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_social_connect = _resolveComponent("social-connect")!
  const _component_email_connect = _resolveComponent("email-connect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_restore_password = _resolveComponent("restore-password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_social_connect, {
      action: "login",
      connecting: _ctx.connecting,
      "onUpdate:connecting": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.connecting) = $event)),
      items: _ctx.allSocialConnections,
      userType: _ctx.userType,
      onConnect: _ctx.handleUserConnect
    }, null, 8, ["connecting", "items", "userType", "onConnect"]),
    _createVNode(_component_email_connect, {
      "sign-in": true,
      onSignIn: _ctx.handleEmailSignIn
    }, null, 8, ["onSignIn"]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" Forgot your password? "),
      _createVNode(_component_router_link, {
        style: {"color":"red","font-weight":"bold","text-decoration":"underline"},
        to: '#',
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showRestoreModal = true;})
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Restore ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(" Don’t have an account? Register. "),
      _createVNode(_component_router_link, {
        style: {"color":"red","font-weight":"bold","text-decoration":"underline"},
        to: { name: 'register' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Register ")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'terms-of-use' })))
        }, " TERMS OF USE |"),
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'legacy-of-notice' })))
        }, "LEGAL NOTICE |"),
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({name: 'privace-policy'})))
        }, " Privacy Policy |")
      ])
    ]),
    _createVNode(_component_restore_password, {
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRestoreModal = false)),
      onRestored: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showRestoreModal = false)),
      show: _ctx.showRestoreModal
    }, null, 8, ["show"])
  ]))
}